import DotIcon from "src/assets/Icons/Giftcards/DotIcon";
import Giftbox from "src/assets/Icons/Giftcards/GiftBox";
import TopupBannerIcon from "src/assets/Icons/Topup/TopupBannerIcon";

export default function BannerHero() {
  return (
    <div className="w-full h-full">
      <div className="animate-twinkle absolute start-16 top-10" style={{ animationDuration: "5s", animationDelay: "1s" }}>
        <DotIcon width={8} height={8} />
      </div>
      <div className="animate-twinkle absolute bottom-2 start-6" style={{ animationDuration: "5s", animationDelay: "2s" }}>
        <DotIcon width={10} height={10} />
      </div>
      <div className="animate-twinkle absolute bottom-6 end-2" style={{ animationDuration: "5s", animationDelay: "4s" }}>
        <DotIcon width={12} height={12} />
      </div>
      <div className="absolute end-0 top-1/2 -translate-y-1/2 w-full h-full">
        <TopupBannerIcon strokeWidth={0.2} className="opacity-30" />
      </div>
    </div>
  );
}
